export const I18N_NS_PILOTAGE_RH = "pilotage_rh";

/* ---------- Filtres ---------- */
/* Clés = valeurs attendues par l'API (param `period`) */
export const PERIODES = [
    { key: "ytd", header: "Year-to-date" },
    { key: "12m", header: "12 mois glissants" },
    { key: "quarter", header: "Trimestre en cours" },
    { key: "month", header: "Mois en cours" },
];

/* Liste en dur tant qu'il n'y a pas d'endpoint de départements */
export const DEPARTEMENTS = [
    "Délégation",
    "Service technique (SPID)",
    "Ventes",
    "Comptabilité et finances",
    "Direction",
    "Conseil et IA",
    "Logistique",
    "Bbalanced",
];

export const DEFAULT_FILTERS = {
    period: "ytd",
    agency_id: null,
    manager_id: null,
    department: null,
};

/* Poids (données de démonstration des sections non branchées) */
export const DEPT_WEIGHT = {
    Délégation: 0.48,
    "Service technique (SPID)": 0.19,
    Ventes: 0.11,
    "Comptabilité et finances": 0.06,
    Direction: 0.05,
    "Conseil et IA": 0.04,
    Logistique: 0.07,
    Bbalanced: 0.02,
};
export const PERIODE_WEIGHT = {
    ytd: 1,
    "12m": 1.9,
    quarter: 0.28,
    month: 0.09,
};

/* ---------- Sections ---------- */
export const SECTIONS = {
    effectif: { id: "sec-effectif", title: "Effectif & Structure" },
    diversite: { id: "sec-diversite", title: "Diversité & Démographie" },
    retention: { id: "sec-retention", title: "Rétention & Ancienneté" },
    mouvements: { id: "sec-mouvements", title: "Mouvements & Turnover" },
    absences: { id: "sec-absences", title: "Absentéisme" },
    temps: { id: "sec-temps", title: "Temps de travail" },
    engagement: { id: "sec-engagement", title: "Engagement" },
    frais: { id: "sec-frais", title: "Notes de frais" },
    taches: { id: "sec-taches", title: "Tâches & Suivi" },
};

/* ---------- Définition des KPI ---------- */
/* label, définition, unité, type de calcul (inst | moy | cum) */
export const KPI = {
    headcount: { label: "Headcount", unit: "collab.", calc: "inst" },
    etp: { label: "ETP", unit: "ETP", calc: "inst" },
    effectif_moyen: { label: "Effectif moyen", unit: "collab.", calc: "moy" },
    evolution_effectif: {
        label: "Évolution de l’effectif",
        unit: "%",
        calc: "cum",
    },
    age_moyen: { label: "Âge moyen", unit: "ans", calc: "inst" },
    femmes_management: {
        label: "Femmes au management",
        unit: "%",
        calc: "inst",
    },
    anciennete: { label: "Ancienneté moyenne", unit: "ans", calc: "inst" },
    mobilite: { label: "Taux de mobilité interne", unit: "%", calc: "cum" },
    absences_jour: { label: "Absences du jour", unit: "collab.", calc: "inst" },
};

/* ---------- Export ---------- */
export const EXPORT_FORMATS = [
    { key: "xlsx", header: "Excel (.xlsx)" },
    { key: "pdf", header: "PDF (.pdf)" },
];

export const EXPORT_AGENCES = ["Genève", "Lausanne", "Zurich"];
export const EXPORT_MANAGERS = [
    "Manager A",
    "Manager B",
    "Manager C",
    "Manager D",
];

export const EXPORT_SYNTHESE_OPTIONS = [
    "Effectif & Structure",
    "Diversité & Démographie",
    "Rétention & Ancienneté",
    "Mouvements & Turnover",
    "Absentéisme",
    "Temps de travail",
    "Engagement",
    "Notes de frais",
    "Tâches & Suivi",
];

export const EXPORT_DETAIL_GROUPS = [
    {
        key: "profil",
        label: "Profil",
        toggleable: false,
        options: [
            { key: "nom", label: "Nom, Prénom", checked: true },
            { key: "role", label: "Rôle", checked: true },
            { key: "poste", label: "Poste", checked: true },
            { key: "dept", label: "Département / Agence", checked: true },
            { key: "contrat", label: "Type de contrat", checked: true },
            { key: "arrivee", label: "Date d'arrivée", checked: true },
            { key: "anciennete", label: "Ancienneté", checked: true },
            { key: "essai", label: "Fin période d'essai", checked: true },
            { key: "naissance", label: "Date de naissance", checked: true },
            {
                key: "categorie",
                label: "Catégorie professionnelle",
                checked: true,
            },
            { key: "genre", label: "Genre", checked: true },
            { key: "taux", label: "Taux d'activité", checked: true },
            { key: "inactif", label: "Inactif", checked: false },
            { key: "depart", label: "Date de départ", checked: false },
        ],
    },
    {
        key: "absenteisme",
        label: "Absentéisme",
        toggleable: true,
        options: [
            { key: "abs_jours", label: "Nombre de jours" },
            { key: "abs_motifs", label: "Motif(s)" },
            { key: "abs_duree", label: "Durée" },
            { key: "abs_freq", label: "Fréquence" },
            { key: "abs_solde", label: "Solde de vacances" },
        ],
    },
    {
        key: "mouvements",
        label: "Mouvements & Turnover",
        toggleable: true,
        options: [
            { key: "mvt_statut", label: "Statut" },
            { key: "mvt_motif", label: "Motif de départ" },
            { key: "mvt_type", label: "Type de turnover" },
        ],
    },
    {
        key: "temps",
        label: "Temps de travail",
        toggleable: true,
        options: [
            { key: "tps_contrat", label: "Heures contractuelles" },
            { key: "tps_declare", label: "Heures déclarées" },
            { key: "tps_sup", label: "Heures supplémentaires" },
            { key: "tps_tele", label: "Jours télétravail" },
        ],
    },
    {
        key: "frais",
        label: "Notes de frais",
        toggleable: true,
        options: [{ key: "frais_total", label: "Montant total" }],
    },
];

/* Collaborateurs (données de staging pour la maquette) */
export const COLLABORATEURS = [
    ["Anaïs Weber", "Direction & Commerce"],
    ["Aurélien Toulouse", "Direction & Commerce"],
    ["Benjamin Silva", "Direction & Commerce"],
    ["Catherine Duval", "Direction & Commerce"],
    ["Emilie Dijol", "Direction & Commerce"],
    ["Milo Frot", "Direction & Commerce"],
    ["Nathalie Girardin", "Direction & Commerce"],
    ["Paul Müller", "Direction & Commerce"],
    ["Sébastien Bovey", "Direction & Commerce"],
    ["Clémence Finance", "Finance & Juridique"],
    ["Gustave Perrier", "Finance & Juridique"],
    ["Léa Meyer", "Finance & Juridique"],
    ["Nelson Grandjean", "Finance & Juridique"],
    ["Sophie Pasche", "Finance & Juridique"],
    ["Alexis Smith", "IT & Digital"],
    ["Augustin Favre", "IT & Digital"],
    ["Camille Nicollier", "IT & Digital"],
    ["Clément Delpierre", "IT & Digital"],
    ["Daniel Rochat", "IT & Digital"],
    ["Frida Silvestri", "IT & Digital"],
    ["Lara Smith", "IT & Digital"],
    ["Malik Khetim", "IT & Digital"],
    ["Yanis Benslimane", "IT & Digital"],
    ["Amélie Leboeuf", "Pilotage & Transformation"],
    ["Anaïs Jean", "Pilotage & Transformation"],
    ["Antoine Schmid", "Pilotage & Transformation"],
    ["Gabrielle Rey", "Pilotage & Transformation"],
    ["Jeanne Hernandez", "Pilotage & Transformation"],
    ["Lucile Dupont", "Pilotage & Transformation"],
    ["Noémie Staging", "Pilotage & Transformation"],
    ["Staging Fiche", "Pilotage & Transformation"],
    ["Thomas Chapuis", "Pilotage & Transformation"],
    ["Alice Gosset", "Ressources humaines"],
    ["Ernest Meier", "Ressources humaines"],
    ["Julien Meylan", "Ressources humaines"],
    ["Patrick Randrianjatovo", "Ressources humaines"],
    ["Pauline Constant", "Ressources humaines"],
    ["Sandrine Lemaire", "Ressources humaines"],
    ["Victor Kleber", "Ressources humaines"],
].map(([name, dept]) => ({ name, dept }));

export const EXPORT_DEPARTEMENTS = [
    ...new Set(COLLABORATEURS.map((c) => c.dept)),
];
